module.exports = __webpack_public_path__ + "static/img/tickets_en.ffda428.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contest/tickets_en.gif
// module id = 80
// module chunks = 0